import React from "react";
import GlobalStyle from "../../pages/AvaNegarLanding/globalStyles";
import {
  Container,
  LandingContainer,
} from "../../pages/AvaNegarLanding/index.styled";
import Footer from "../avanegarFooter";
import NavbarLanding from "../avanegarLandingHeader";
import {
  EnamadContainer,
  FooterAddress,
  FooterAddressItem,
  FooterButtom,
  FooterContainer,
  FooterContent,
  FooterNav,
  FooterWrapper,
  LogoContainer,
  RoleContainer,
  TextContainer,
} from "./role.styled";
import { Link } from "react-router-dom";
import RoleHeader from "../RoleHeader/RoleHeader";
const Role = () => {
  return (
    <>
      <GlobalStyle />
      <LandingContainer>
        <Container>
          <RoleHeader />
        </Container>
        <Container>
          <RoleContainer>
            <p>
              ۱- کلیه اصول و رویه‏‌های آوانگار منطبق با قوانین جمهوری اسلامی
              ایران، قانون تجارت الکترونیک، قانون جرائم رایانه­‌ای و قانون حمایت
              از حقوق مصرف کننده است. کاربران نیز موظف به رعایت قوانین دولتی
              مرتبط با خود می‌باشند. آوانگار هیچگونه مسؤولیتی نسبت به عدم رعایت
              قوانین از سوی کاربر نخواهد داشت و مسؤولیت ناشی از عدم رعایت قوانین
              فوق توسط ایشان به عهده خود ایشان خواهد بود.
            </p>
            <p>
              ۲- اطلاعات شخصی مراجعه­‌کنندگان به سایت ممکن است در موارد زیر توسط
              آوانگار دریافت یا ذخیره شود:
              <ul>
                <li>
                  با ورود به سامانه آوانگار، اطلاعاتی هم­چون آدرس­‌های پروتکل
                  اینترنت، نوع مرورگر، عرضه کننده خدمات اینترنتی ، صفحات کلیدی و
                  خروجی از مرورگر کاربر برای آوانگار ارسال می­‌شود. آوانگار از
                  این اطلاعات در جهت تحلیل داده ها و بهتر کردن کیفیت خدمات
                  استفاده می­‌کند.
                </li>
                <li>
                  در صورتی که کاربر سایت از گزینه اشتراک­‌گذاری با دوستان
                  استفاده نماید، اطلاعاتی از گیرنده از جمله نام کاربری یا آدرس
                  ایمیل طرف مقابل در دسترس آوانگار قرار می­‌گیرد.
                </li>
                <li>
                  در صورت تکمیل فرم تماس با آوانگار توسط کاربر سایت، اطلاعات
                  تماس کاربر جهت ارائه بازخورد هرچه بهتر به او ذخیره می شود.
                </li>
                <li>
                  در صورتی که کاربر سایت پیشنهاد آوانگار برای دریافت ایمیل­‌های
                  خبری و تبلیغاتی ما را بپذیرد یا در صورتی که بخواهد با آوانگار
                  تماس بگیرد باید نشانی ایمیل خود را در اختیار آوانگار بگذارد.
                </li>
                <li>
                  برای ارائه بهتر خدمات و کمک به صرفه­‌جویی در زمان، در چند
                  مورد، مثلاً در زمان ورود کاربر به سایت و در زمانی که کامنتی
                  ارسال می­‌کند، برخی اطلاعات وی مثل اسم، آدرس ایمیل و وبسایت
                  کاربر در قالب کوکی­‌ها ذخیره می­‌شود. عمر کوکی­‌ها بسته به
                  مورد بین دو روز تا یک سال است. کوکی­‌هایی که با ورود کاربر به
                  سایت آوانگار ایجاد می­‌شود با خروج کاربر از حساب کاربری حذف
                  خواهند شد.
                </li>
              </ul>
            </p>
            <p>
              ۳- مالکیت فکری محتواهای قابل دسترس در آوانگار متعلق به آوانگار است
              و هر گونه استفاده بدون مجوز از آنها از جمله نفوذ در نرم­‌افزارهای
              سامانه، بازتولید، مهندسی معکوس، فروش و اعطای لیسانس توسط سایرین،
              صرف‌نظر از آنچه در بند قبل ذکر شده، نقض حقوق دارنده خواهد بود.
            </p>
            <p>
              ۴- استفاده از اسم، علامت تجاری و سایر اموال فکری متعلق به آوانگار
              صرفاً جهت معرفی و تبلیغ محصولات نامبرده در چارچوب همکاری با
              آوانگار مجاز است. هر گونه استفاده دیگر از این اموال، از جمله همه
              ایده­‌های اعلام شده، محصولات، سرویس­‌ها و محتوای منتشر شده در
              وبسایت­‌های ...... و زیردامنه­‌های آن، بدون کسب اجازه از آوانگار
              ممنوع خواهد بود.
            </p>
            <p>
              ۵- مسؤولیت ناشی از نقض کپی­‌ رایت محتوای متعلق به اشخاص ثالث برابر
              قوانین ایران و قوانین بین­‌المللی با کاربر است و آوانگار مسؤولیتی
              در این باره نخواهد داشت.
            </p>
          </RoleContainer>
        </Container>
        <Container>
          <FooterContainer className="container">
            <LogoContainer>
              <h2>آوانــگـــار</h2>
            </LogoContainer>
            <FooterWrapper>
              <FooterContent>
                <TextContainer
                  color="#424243"
                  className="footer-contnet"
                  width="586px"
                  height="190px"
                >
                  <p>
                    هوش مصنوعی روزبه‌روز خدمات متنوعی را در اختیار ما قرار
                    می‌دهد و نیازهای گوناگون ما در هر حوزه‌ای به کمک این فناوری
                    در حال برآورده شدن است. سرویس تبدیل صوت به متن فارسی از آن
                    دسته خدماتی است که با استفاده از فناوری هوش مصنوعی برای
                    بهبود رابط کاربری و ایجاد سهولت بیشتر برای فارسی زبانان
                    توسعه داده شده و به صورت یک API قابل ادغام با نرم‌افزارها و
                    اپلیکیشن‌هاست.
                  </p>
                </TextContainer>
              </FooterContent>

              <FooterAddress>
                <FooterAddressItem width="342px" height="64px">
                  <p>
                    تهران، میدان کاج، خیابان سرو شرقی، خیابان مجد کوچه نسترن،
                    پلاک ۳۴
                  </p>
                </FooterAddressItem>
                <FooterAddressItem width="342px" height="32px">
                  <p>شماره پشتیبانی : ۷۴۳۱۸۸۳۵ - ۰۲۱</p>
                </FooterAddressItem>
                <FooterAddressItem width="342px" height="32px">
                  <p>شماره فروش : ۷۴۳۱۸۰۵۰ - ۰۲۱</p>
                </FooterAddressItem>
                <FooterAddressItem width="342px" height="32px">
                  <span>ایمیل فروش: </span>
                  <a href="mailto:market@partdp.ir">market@partdp.ir</a>
                </FooterAddressItem>
                <EnamadContainer>
                  <a
                    // referrerpolicy="origin"
                    target="_blank"
                    href="https://trustseal.enamad.ir/?id=270942&amp;Code=tsBXc81vmdWikQ7xk1hF"
                  >
                    <img
                      // referrerpolicy="origin"
                      src="https://Trustseal.eNamad.ir/logo.aspx?id=270942&amp;Code=tsBXc81vmdWikQ7xk1hF"
                      alt="enamad"
                      id="tsBXc81vmdWikQ7xk1hF"
                      style={{ width: "100px", height: "100px" }}
                    />
                  </a>
                </EnamadContainer>
              </FooterAddress>
            </FooterWrapper>
            <FooterButtom>
              <div>
                تمامی حقوق و محتوا برای{" "}
                <a
                  href="https://partdp.ai/fa/"
                  target="_blank"
                  rel="noreferrer"
                >
                  مرکز تحقیقات هوش مصنوعی پارت
                </a>{" "}
                محفوظ است. ۱۴۰۲
              </div>
            </FooterButtom>
          </FooterContainer>
        </Container>
      </LandingContainer>
    </>
  );
};

export default Role;
